import { GenericProgram, ProgramCategory } from '@gql/generated';
import styled from 'styled-components';
import { Box } from '@components/layout/Grid';

export const Label = styled.label<{
  status?: string;
  borderColor: string;
}>`
  border-radius: 50%;
  height: 20px;
  width: 20px;
  padding: 1px;
  text-align: center;
  left: 0;
  top: 0;
  line-height: ${props =>
    props.status === 'locked' || props.status === 'open' ? `14px` : `16px`};
  font-size: 11px;
  border: 2px solid ${props => props.borderColor};
  font-weight: 600;
  ${props =>
    props.status === 'locked' || props.status === 'open'
      ? `
          background-color: white;
          color: ${props.borderColor};
        `
      : `
          background-color: ${props.borderColor};
          color: white;
        `};
  color: ${props => (props.status === 'locked' ? '#242424' : null)};
  position: absolute;
`;

export const VideoBoxSC = styled(Box)`
  border-left: ${props =>
    props.isLast ? null : `2px solid ${props.borderColor}`};
`;

export const ProgressStatus = styled.label<{
  active?: boolean;
  isHighlighted?: boolean;
  appearance?: ProgramCategory;
}>`
  flex-shrink: 0;
  position: relative;
  display: inline-block;
  height: 20px;
  width: 20px;
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  margin-top: .3em;
  margin-right: 10px;
  
  background-color: ${props => {
    if (props.active) {
      if (props.appearance === ProgramCategory['Challenges']) {
        return props.theme.colors.primary['green'];
      } else {
        return props.theme.colors.primary['blue-2'];
      }
    } else {
      return props.isHighlighted ? 'white' : 'transparent';
    }
  }};
  ${props =>
    props.active
      ? `
          &:before {
            content: '\\e944';
            font-family: 'ygb-font' !important;
            speak: none;
            font-style: normal;
            font-weight: normal;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
            position: absolute;
            font-size: 13px;
            left: 0px;
            top: 2px;
            color: #fff;
            /* Better Font Rendering =========== */
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }
        `
      : null}
  border: 2px solid
    ${props => {
      if (props.active || props.isHighlighted) {
        if (props.appearance === ProgramCategory['Challenges']) {
          return props.theme.colors.primary['green'];
        } else {
          return props.theme.colors.primary['blue-2'];
        }
      }
      return props.theme.colors.neutrals['gray-3'];
    }};
`;

export const P = styled.p`
  padding-left: 20px;
`;

export const DaySection = styled.div<{ isCurrentDay?: boolean }>`
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 3px;
  background-color: ${props => (props.isCurrentDay ? `#dff5ff` : null)};

  @media (max-width: ${props => `${props.theme.viewports.tablet + 1}px`}) {
    padding-left: 5px;
    padding-right: 5px;
  }
`;

export const WeekLabel = styled.p`
  color: ${({ theme }) => theme.colors.neutrals.black};
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
`;

export const MetaBox = styled.div<{ appearance?: GenericProgram['category'] }>`
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  text-transform: lowercase;
  border: 1px solid #dce1e7;
  padding: 20px;

  i:before {
    color: ${({ appearance, theme }) =>
      appearance === ProgramCategory['Challenges']
        ? theme.colors.primary['green']
        : theme.colors.primary['blue-1']};
  }

  @media (min-width: ${props => `${props.theme.viewports.tablet + 1}px`}) {
    min-width: 196px;
  }
`;

export const ProgressBarWrapper = styled.div`
  overflow: hidden;
  border-radius: 3px;
`;

export const DayLabel = styled.span<{ isHighlighted?: boolean }>`
  text-transform: uppercase;
  line-height: 20px;
  vertical-align: middle;
  display: inline-block;
  margin-top: 3px;
  ${props =>
    props.isHighlighted
      ? `color: ${props.theme.colors.primary['blue-2']}`
      : ''};
`;
export const ProgressBarItem = styled.div<{
  backgroundColor?: string;
  isActive?: boolean;
}>`
  cursor: pointer;
  background-color: ${props => props.backgroundColor};
  flex: 1;
  padding: 20px;
  color: ${props =>
    props.isActive ? 'white' : props.theme.colors.primary['blue-4']};
  border-bottom: ${props => props.isActive && `3px solid #56B9E5`};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  & span {
    margin-left: 10px;
    background-color: #9dc9c7;
    border-radius: 3px;
    color: white;
    font-size: 11px;
    font-weight: 600;
    padding: 5px;
  }
  &:after {
    font-family: 'ygb-font' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    content: '\\e902';
    color: ${props => props.backgroundColor};
    font-size: 18px;
    position: absolute;
    right: -10px;
    z-index: 1;
  }
  &:last-child {
    &:after {
      content: none;
    }
  }
`;
